<input
    [ngModel]="text"
    (ngModelChange)="onValueChange.emit($event)"
    id="{{fieldId}}"
    (blur)="handleBlur()"
    (focus)="handleFocus()"
    [type]="fieldType"
    maxlength="{{maxlength}}"
    class="field__input"
/>
